import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelUnscheduleShipment} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class UnscheduleShipmentFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.unscheduleShipment(updatedValues)
      .then((response) => {
        if (response.data.unscheduleShipment.errors.length <= 0) {
          this.props.cancelUnscheduleShipment();
        } else {
          let errors = createValidationErrors(response.data.unscheduleShipment.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelUnscheduleShipment();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message={"Are you sure you want to unschedule this shipment?"}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const UNSCHEDULE_SHIPMENT = gql`
  mutation unscheduleShipment($data: UnscheduleShipmentInput!) {
    unscheduleShipment(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(UNSCHEDULE_SHIPMENT, {
    props: ({ mutate }) => ({
      unscheduleShipment: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelUnscheduleShipment})(withMutation(UnscheduleShipmentFormContainer));